import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=4dab61fe&scoped=true"
import script from "./roleEdit.vue?vue&type=script&lang=js"
export * from "./roleEdit.vue?vue&type=script&lang=js"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=4dab61fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dab61fe",
  null
  
)

export default component.exports